import React from "react";
import { notify } from "@/shared/utils/notify";
import { categoriesService } from "../../../shared/services";

export interface ICategory {
  id: number;
  name: string;
  parent_id: number | null;
  position: number;
  status: string;
}

export const useCategories = () => {
  const [loading, setLoading] = React.useState<boolean>(false);
  const [categories, setCategories] = React.useState<ICategory[]>([]);

  const getCategories = async () => {
    if (loading) return;

    setLoading(true);
    try {
      const res = await categoriesService.find({
        query: {
          status: "active",
          $sort: { name: 1 },
          $limit: 500,
        },
      });
      setCategories(res.data || []);
    } catch (err: any) {
      notify.error(err.message);
    } finally {
      setLoading(false);
    }
  };

  React.useEffect(() => {
    getCategories();
  }, []);

  return {
    loading,
    categories,
    getCategories,
  };
};
